import { render, staticRenderFns } from "./referrer-details-container.vue?vue&type=template&id=608e3632"
import script from "./referrer-details-container.vue?vue&type=script&lang=js"
export * from "./referrer-details-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports